<div class="step-two">
  <h3>Resumen</h3>
  <div class="step-two__container">
    <div class="step-two__container-change">
      <div class="step-two__coins">
        <p class="step-two__text">Vas a cambiar</p>
        <div class="step-two__coins-text">
          <img
            [src]="'/assets/icons/crypto/' + data.fromTicker.toLowerCase() + '.svg'"
            alt="coin"
          />
          <p>{{ data.fromTicker | arsUsdLabel }}<span>por</span></p>
          <img [src]="'/assets/icons/crypto/' + data.toTicker.toLowerCase() + '.svg'" alt="coin" />
          <p>{{ data.toTicker | arsUsdLabel }}</p>
        </div>
      </div>
      <div class="step-two__frecuency">
        <p class="step-two__text">Frecuencia</p>
        <p class="step-two__text-white">{{ data.frequency | frequencyTransform }}</p>
      </div>
    </div>
    <div class="step-two__create">
      <div class="step-two__step">
        <div class="step-two__step-point"></div>
        <div class="step-two__step-line"></div>
        <div class="step-two__step-point"></div>
      </div>
      <div class="step-two__create-information">
        <div>
          <p class="step-two__text">Fecha de creación</p>
          <p class="date">{{ creationDate | date : 'yyyy-M-d HH:mm' }}</p>
        </div>
        <div>
          <p class="step-two__text">Cantidad por período</p>
          <p class="date">{{ data.amount + ' ' + (data.fromTicker | arsUsdLabel) }}</p>
        </div>
        <div>
          <p class="step-two__text">Primera fecha de inversión automática</p>
          <p class="date">{{ firstDateAutomaticInvestment | date : 'yyyy-M-d HH:mm' }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="step-two__container-btn">
    <button class="td-btn btn-contained" (click)="back()">Volver</button>
    <button class="td-btn primary btn-confirm" (click)="!isSendRule ? this.sendRule() : ''">
      Confirmar
    </button>
  </div>
</div>
